import { BindAll } from 'lodash-decorators'
import { $service } from '@xt/client/experimental/request/service'
import { action, observable, toJS } from 'mobx'

import type { SettingsItemIcon } from '@xt/client/entities/user/types.d'

/**
 * 暄桐
 */
const XT_MSG = 0b1000
/**
 * 微信平台
 */
const WECHAT_FLAG = 0b0100
/**
 * 邮箱平台
 */
const EMAIL_FLAG = 0b0010
/**
 * 短信平台
 */
const SMS_FLAG = 0b0001

type NotificationType = 'Wechat' | 'Email' | 'SMS'

export type NotificationConfig = {
  icon: SettingsItemIcon
  type: NotificationType
  mask: number
  enable: boolean
  title: string
  description: string
}

@BindAll()
export class MySettingsNoticeController {
  @observable list: Array<NotificationConfig> = []

  @observable isReady: boolean = false

  @action
  private setList(mask: number) {
    this.list = [
      {
        type: 'Wechat',
        icon: 'wechat',
        mask: WECHAT_FLAG,
        title: '微信通知',
        description: '关闭后不再发送微信消息提醒',
        enable: !!(mask & WECHAT_FLAG)
      },
      {
        type: 'SMS',
        icon: 'sms',
        mask: SMS_FLAG,
        title: '短信通知',
        description: '关闭后不再发送短信提醒',
        enable: !!(mask & SMS_FLAG)
      },
      {
        type: 'Email',
        icon: 'email',
        mask: EMAIL_FLAG,
        title: '邮件通知',
        description: '关闭后不再发送邮件提醒',
        enable: !!(mask & EMAIL_FLAG)
      }
    ]
  }

  @action
  private updateList(newList: Array<NotificationConfig>) {
    this.list = newList
  }

  @action
  private setReady(isReady: boolean) {
    this.isReady = isReady
  }

  public async onChangeNoticeSettings(item: NotificationConfig) {
    let result = XT_MSG

    const rollbackList = toJS(this.list)

    const nextList = this.list.map(old => {
      if (old.type === item.type) {
        return {
          ...old,
          enable: !item.enable
        }
      }

      return old
    })

    nextList.forEach(_item => {
      if (_item.enable === true) {
        result |= _item.mask
      }
    })

    this.updateList(nextList)
    const [, success] = await $service<boolean>({
      method: 'PUT',
      url: '/notice/api/notice/member/platform/setting',
      data: {
        platformSetting: result
      },
      params: {
        platformSetting: result
      }
    })

    if (success === true) {
      return true
    }

    // 回滚
    this.updateList(rollbackList)
    return false
  }

  public async loadNoticeSettings() {
    if (this.isReady) return

    const [, mask] = await $service<number>({
      method: 'GET',
      url: '/notice/api/notice/member/platform/setting'
    })

    if (typeof mask === 'number') {
      this.setList(mask)
      this.setReady(true)
    }
  }

  @action
  public reset() {
    this.isReady = false
    this.list = []
  }
}
